<template>
  <el-dialog
    title="编辑报表信息"
    :visible="salaryDialogType == 'info'"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    @open="initDialog"
    width="50%"
  >
    <div>
      <el-form
        label-position="right"
        label-width="150px"
        :model="salaryReportDetails"
      >
        <el-form-item label="报表名称">
          <p>{{ salaryReportDetails.name }}</p>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="salaryReportDetails.remark"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="updateSalaryReport" :loading="isLoading"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { managerUpdateSalaryReport } from '@/api/manager'
export default {
  data() {
    return {
      isLoading: false,
      salaryReportDetails: {},
    }
  },
  props: ['salaryDialogType', 'reportData'],
  methods: {
    // 关闭模态框
    closeDialog() {
      this.salaryReportDetails = {}
      this.$emit('update:salaryDialogType', false)
    },
    // 初始化模态框
    async initDialog() {
      this.salaryReportDetails = { ...this.reportData }
    },
    // 保存报表信息
    async updateSalaryReport() {
      let postData = {
        id: this.salaryReportDetails.id,
        remark: this.salaryReportDetails.remark,
      }
      this.isLoading = true
      let { code, msg } = await managerUpdateSalaryReport(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.$emit('updateSalaryList')
        this.closeDialog()
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
